export const math_task__assignment_type: Record<string, string> = {
  0: "",
  1: "Innlæring",
  2: "Mengdetrening",
}
